import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Typography, Box, Grid, Checkbox, FormControlLabel, Button } from '@mui/material';

import * as CommonActions from '../../../../../store/actions/common.action';
import { getCommonState } from '../../../../../store/selector/common.selector';
import { ISignatoryModal } from '../../../../interfaces/modal.interface';

const styles = {
  modalContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { sm: 600, xs: '100%' },
    bgcolor: 'background.paper',
    borderRadius: { sm: '0.5rem', xs: 0 },
    boxShadow: 24,
    p: 4,
  },

  modalButton: {
    padding: '0.5rem 3rem',
    borderRadius: '2.5rem',
    width: { sm: 'auto', xs: '100%' },
  },
};

const SignatoryAdd = ({ isModalOpen, params, onClickModal }: ISignatoryModal) => {
  const dispatch = useDispatch();
  const {
    signatories: { items },
  } = useSelector(getCommonState);

  const [selectedSignatories, setSelectedSignatories] = useState<Array<string>>([]);

  const onSelectSignatory = (item: string) => {
    setSelectedSignatories([...selectedSignatories, item]);
  };

  useEffect(() => {
    if (isModalOpen) dispatch(CommonActions.CommonFetchSignatories(params));
  }, [isModalOpen]);

  return (
    <Modal open={isModalOpen}>
      <Box sx={styles.modalContainer}>
        <Box>
          <Typography sx={{ fontSize: '1.75rem' }} color='primary'>
            Signatory List
          </Typography>

          {items && (
            <Grid container sx={{ margin: '2rem 1rem' }}>
              {items.map((item: string, idx: string) => {
                return (
                  <Grid item key={idx} xs={12}>
                    <FormControlLabel
                      control={<Checkbox onChange={() => onSelectSignatory(item)} />}
                      label={item}
                    />
                  </Grid>
                );
              })}
            </Grid>
          )}

          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              variant='contained'
              sx={{ ...styles.modalButton, mr: '1rem' }}
              onClick={() => onClickModal('confirm', selectedSignatories)}
              disableElevation
            >
              Confirm
            </Button>
            <Button
              color='inherit'
              variant='contained'
              sx={styles.modalButton}
              onClick={() => onClickModal('cancel')}
              disableElevation
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};
export default SignatoryAdd;
